import React, { memo } from 'react'
import classNames from 'classnames'
import { makeStyles } from 'transfix-ui/core'
import { brandColors } from 'transfix-ui/theme/colors'
import { INavRoute } from 'types/routes'
import SubRoute from './SubRoute'

const useSubRoutesMenuStyles = makeStyles(theme => ({
  root: {
    display: 'none',
    margin: 0,
    padding: 0,
    height: 'auto',
    boxShadow: '0px 4px 4px 0px rgba(0, 0, 0, 0.25)',
    backgroundColor: brandColors.coolGray8,
    color: brandColors.coolGray2,
    width: 170,
    listStyleType: 'none',
  },
  hover: {
    [theme.breakpoints.up('md')]: {
      display: 'block',
      position: 'absolute',
      top: '100%',
      left: '50%',
      transform: 'translate(-50%, 0)',
    },
  },
}))

interface ISubRoutesMenuProps {
  className?: string
  /**
   * @default false
   */
  isHover?: boolean
  routes: INavRoute[]
}

const SubRoutesMenu = memo<ISubRoutesMenuProps>(
  ({ className: classNameProp, routes: routesProp = [], isHover }) => {
    const classes = useSubRoutesMenuStyles()
    const className = classNames(classes.root, classNameProp, {
      [classes.hover]: isHover,
    })

    const filteredRoutes = routesProp.filter(({ display }) => !!display)
    return (
      <ul className={className} data-test='SubRoutesMenu'>
        {filteredRoutes.map(childRoute => (
          <SubRoute route={childRoute} key={childRoute.name} />
        ))}
      </ul>
    )
  }
)

export default SubRoutesMenu
